import { useState } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const notices = [
  {
    id: 1,
    category: "공지",
    title: "수포자 대신 수학 우등생으로! 2026 수학 갓생살기 프로젝트",
    date: "2026-01-04",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224133884620",
    thumb: "https://blogthumb.pstatic.net/MjAyNjAxMDRfMTAw/MDAxNzY3NTEyNDQzMTU3.SJGtoz4t_lCu3-nov0ZSBNI0jaLTqmalRsMSAjvHlCgg.DgeY5kBPepcGEsMt4RS6c_5eVrCiZEkp0BXMvoIky9Ag.JPEG/900%25A3%25DF1767508385733.jpg?type=s2",
  },
  {
    id: 2,
    category: "공지",
    title: "2026년 새해, 오답은 가고 만점의 기쁨이 가득하시길 바랍니다",
    date: "2026-01-02",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224131349081",
    thumb: "https://blogthumb.pstatic.net/MjAyNjAxMDJfMjQ0/MDAxNzY3MzE5OTQ2Njk3.5X1t8-poiONe_Zp4X3Br2mCpP-LKePfiFlTtydPp9L4g.gSm8dGhBihO4LWZ1YKq7rhcDTeCzOa_SdWcexP0yXwwg.JPEG/900%25A3%25DF1767144730680.jpg?type=s2",
  },
  {
    id: 3,
    category: "공지",
    title: "[대치] 고등 상위권 직행! 2026 FMA 수학 '개념의 힘'을 믿으세요!",
    date: "2025-12-31",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224128908527",
    thumb: "https://blogthumb.pstatic.net/MjAyNTEyMzFfMTIw/MDAxNzY3MTQ1OTAwNjgw.UAcxtlXq4gxpg0GZuS6LtMB2-nk1HKsZrnDFmjLat88g.dLjeEZo1ioIZgpJObI7b_3RO1vG7828oD451xI-GHUEg.JPEG/900%25A3%25DF1767144732868.jpg?type=s2",
  },
  {
    id: 4,
    category: "공유",
    title: "[공유] 겨울방학 2개월이 수능까지 결정한다? 예비중~고3 학년별 수학 로드맵",
    date: "2025-12-29",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224126147208",
    thumb: "https://blogthumb.pstatic.net/MjAyNTEyMjlfMjk3/MDAxNzY2OTcwMTU3NjA2.kejKVMr5y2hiIjcEruhL_XS3iwHwR8NwmWZ2CM_3SPIg.IGvfHr8ibq2pPLW91uAnDnYpG286pvWvN3LAJWt7oi4g.JPEG/900%25A3%25DF1766911935160.jpg?type=s2",
  },
  {
    id: 5,
    category: "공지",
    title: "[대치/한티] 수학, 고민만 하면 '남의 점수'가 됩니다. F.M.A 겨울방학 개념완성반",
    date: "2025-12-26",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224123037697",
    thumb: "https://blogthumb.pstatic.net/MjAyNTEyMjZfMjE1/MDAxNzY2NzI1NTU0MDE1.u9kvz8J1Qrvfed-Wy7F0hzbJkVFPNmP9EPC0UEliZCwg.hF9vwK4XK383GxRHGcKQtRZ2EADwU9mmhFETwOIMBr8g.PNG/900%25A3%25DF1766725023774.png?type=s2",
  },
  {
    id: 6,
    category: "공지",
    title: "20년 외길, 대치동이 뒤늦게 쫓아오는 FMA수학의 독보적 개별 맞춤 시스템을 소개합니다",
    date: "2025-12-22",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224118919555",
    thumb: "https://blogthumb.pstatic.net/MjAyNTEyMjJfMTM2/MDAxNzY2Mzk4MDY1NDIz.GflR0obFJZT2jp-MNmGT0ub7qA9ASgWiS1USnLX0rR4g._TzcAmvgdps4JmTOOIdb1hFVKUmlKFP2PCm0Cj6BabQg.PNG/900%25A3%25DF1766364734530.png?type=s2",
  },
  {
    id: 7,
    category: "공지",
    title: "[대치동 수학] 흔들리는 개별지도 사이, 20년 정통의 실력 – FMA 초등부 겨울특강",
    date: "2025-12-19",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224115384676",
    thumb: "https://blogthumb.pstatic.net/MjAyNTEyMTlfMjYg/MDAxNzY2MTE5MzgzNTA0.C0vuXhyIKIoTf00svxOC3bDMdjBgywN5X7BK9ega_hkg.Kqi1cYEMDeTMHjkKXhRZlzeCIpcWUUMi_DbM0mCCBgYg.JPEG/900%25A3%25DF1766059214157.jpg?type=s2",
  },
  {
    id: 8,
    category: "후기",
    title: "[솔직후기] FMA 수학, 개념은 꽉 잡는데 숙제가 적어서 고민했어요 (ft. 중등/고등 고민맘 필독)",
    date: "2025-12-17",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=224112704415",
    thumb: "https://blogthumb.pstatic.net/MjAyNTEyMTdfMjI1/MDAxNzY1OTM2NDI2MDk2.2kUHnnnFlQ7D4eaLrKF77Dh46Wjg-f6g0i7R5dN_cREg.J-xeaW2HZy_u1sAXvH_QJvsDMtSIOdN7R6O6sKUg0FAg.JPEG/1765935205729.jpg?type=s2",
  },
];

const schedule = [
  { grade: "초등부", time: "수업 시간 문의", teacher: "김희삼 원장님", spots: "문의 필요" },
  { grade: "중학교 1-2학년", time: "수업 시간 문의", teacher: "김희삼 원장님", spots: "문의 필요" },
  { grade: "중학교 3학년", time: "수업 시간 문의", teacher: "김희삼 원장님", spots: "문의 필요" },
  { grade: "고등학교 1학년", time: "수업 시간 문의", teacher: "김희삼 원장님", spots: "문의 필요" },
  { grade: "고등학교 2-3학년 (수능반)", time: "수업 시간 문의", teacher: "김희삼 원장님", spots: "문의 필요" },
  { grade: "수리논술반", time: "수업 시간 문의", teacher: "김희삼 원장님", spots: "문의 필요" },
];

export default function Notice() {
  const [tab, setTab] = useState<"notice" | "schedule">("notice");

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#1E3A5F] mb-4">공지사항 및 시간표</h1>
          <p className="text-slate-500 text-lg">최신 소식과 수업 일정을 확인하세요</p>
        </div>

        {/* Tab */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex bg-slate-100 rounded-full p-1">
            <button
              onClick={() => setTab("notice")}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                tab === "notice" ? "bg-white text-[#1E3A5F] shadow-sm" : "text-slate-500"
              }`}
            >
              공지사항
            </button>
            <button
              onClick={() => setTab("schedule")}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                tab === "schedule" ? "bg-white text-[#1E3A5F] shadow-sm" : "text-slate-500"
              }`}
            >
              수업 시간표
            </button>
          </div>
        </div>

        {tab === "notice" && (
          <div className="space-y-4">
            {notices.map((notice) => (
              <a
                key={notice.id}
                href={notice.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-5 bg-white rounded-2xl p-5 border border-slate-100 hover:border-[#2563EB]/30 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
              >
                <div className="w-16 h-16 rounded-xl overflow-hidden shrink-0">
                  <img
                    src={notice.thumb}
                    alt={notice.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full whitespace-nowrap ${
                      notice.category === "후기"
                        ? "bg-emerald-50 text-emerald-600"
                        : notice.category === "공유"
                        ? "bg-[#F59E0B]/10 text-[#D97706]"
                        : "bg-[#2563EB]/10 text-[#2563EB]"
                    }`}>
                      {notice.category}
                    </span>
                  </div>
                  <p className="font-medium text-slate-700 text-sm leading-snug truncate">{notice.title}</p>
                  <p className="text-xs text-slate-400 mt-1">{notice.date}</p>
                </div>
                <div className="shrink-0">
                  <i className="ri-arrow-right-s-line text-slate-300 text-xl" />
                </div>
              </a>
            ))}
            <div className="text-center pt-4">
              <a
                href="https://blog.naver.com/fmasky"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-[#1E3A5F] hover:bg-[#2563EB] text-white font-medium rounded-lg text-sm transition-colors cursor-pointer gap-2"
              >
                <i className="ri-global-line" />
                네이버 블로그에서 더 보기
              </a>
            </div>
          </div>
        )}

        {tab === "schedule" && (
          <div>
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              {schedule.map((s) => (
                <div key={s.grade} className="bg-white rounded-2xl p-6 border border-slate-100">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="font-bold text-[#1E3A5F]">{s.grade}</h3>
                    <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-[#2563EB]/10 text-[#2563EB] whitespace-nowrap">
                      {s.spots}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-slate-500 mb-2">
                    <i className="ri-time-line text-[#2563EB]" />
                    {s.time}
                  </div>
                  <div className="flex items-center gap-2 text-sm text-slate-500">
                    <i className="ri-user-line text-[#2563EB]" />
                    {s.teacher}
                  </div>
                </div>
              ))}
            </div>
            <div className="bg-[#2563EB]/5 rounded-2xl p-6 text-center">
              <p className="text-slate-600 mb-4">정확한 수업 시간표 및 반 편성은 전화 문의 또는 방문 상담을 통해 안내드립니다.</p>
              <a
                href="tel:010-2368-3385"
                className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-[#2563EB] hover:bg-[#1d4ed8] text-white font-bold rounded-lg text-sm transition-colors cursor-pointer gap-2"
              >
                <i className="ri-phone-line" />
                010-2368-3385 전화 문의
              </a>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
